import { Dispatch } from 'redux';
import { AppState } from '../types/app-state';
import { Action } from '../types/action';
import { ForgotPasswordState } from '../types/forgotpassword-state';
import { forgotPassword, changePassword } from '../services/auth';
import { USER_CHANGED_PASSWORD } from './auth.constants';
import * as Constants from './forgotpassword.constants';

export interface SetVerificationDetailsType {
  token: string;
  codeVerified: boolean;
}

export interface SetErrorMessageAction extends Action {
  message: string | null;
}
export interface SetUserDetailsAction extends Action, Partial<ForgotPasswordState> { }

export interface SetVerificationDetailsAction extends Action, Partial<SetVerificationDetailsType> { }

export function GetVerificationCode(email: string) {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: Constants.GET_VERIFICATION_CODE });
      dispatch(SetUserDetails({ email, loading: true }));
      const { status, message, data } = await forgotPassword(email);
      if (status !== 1) {
        throw new Error(status === -1 ? 'A server error occurred' : message);
      }
      dispatch(SetVerificationDetails({ ...data }));
      dispatch(SetErrorMessage(null));
    } catch (error) {
      dispatch(SetErrorMessage(error.message));
    }
  };
}

export function ChangePassword(password: string, code: string) {
  return async (dispatch: Dispatch<any>, getState: () => AppState) => {
    try {
      const { email, token } = getState().forgotpassword;
      dispatch({ type: Constants.GET_VERIFICATION_CODE });
      dispatch(SetUserDetails({ loading: true }));
      if (email && token) {
        const result = await changePassword(email, token, password, code);
        if (result.status !== 1) {
          throw new Error(result.status === -1 ?
            'Verification code already expired. Please refresh the page to start over.' : result.message);
        } else if (result.data) {
          dispatch(SetVerificationDetails({ codeVerified: true }));
          dispatch({ type: USER_CHANGED_PASSWORD });
        }
      }
      dispatch(SetErrorMessage(null));
    } catch (error) {
      dispatch(SetErrorMessage(error.message));
    }
  };
}

export function SetErrorMessage(message: string | null): SetErrorMessageAction {
  return {
    type: Constants.SET_ERROR_MESSAGE,
    message
  };
}

export function SetUserDetails(details: Partial<ForgotPasswordState>): SetUserDetailsAction {
  return {
    type: Constants.SET_USER_DETAILS,
    ...details
  };
}

export function SetVerificationDetails(details: Partial<SetVerificationDetailsType>): SetVerificationDetailsAction {
  return {
    type: Constants.SET_VERIFICATION_DETAILS,
    ...details
  };
}

export function Reset(): Action {
  return {
    type: Constants.RESET,
  };
}

export type All
  = Action
  | SetErrorMessageAction
  | SetUserDetailsAction
  | SetVerificationDetailsAction;